
import AddCircle from "../../../assets/outline/AddCircle.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function AddCircleIcon({ className, dataTestid = "AddCircleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <AddCircle data-testid={dataTestid} className={classes} {...rest} />
  );
}
